import React from 'react';

const RightSidebar = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="w-80 border-l overflow-y-auto" style={{ backgroundColor: 'var(--bg-primary)', borderColor: 'var(--text-secondary)' }}>
      <div className="p-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium" style={{ color: 'var(--text-primary)' }}>Chat Controls</h3>
          <button 
            onClick={onClose}
            style={{ color: 'var(--text-secondary)' }}
            className="hover:text-white"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Values Section */}
        <div className="mb-6">
          <button className="flex items-center justify-between w-full text-left mb-2" style={{ color: 'var(--text-primary)' }}>
            <span>Values</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>

        {/* System Prompt Section */}
        <div className="mb-6">
          <button className="flex items-center justify-between w-full text-left mb-2" style={{ color: 'var(--text-primary)' }}>
            <span>System Prompt</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
            </svg>
          </button>
          <div className="text-sm mb-2" style={{ color: 'var(--text-secondary)' }}>Enter system prompt</div>
        </div>

        {/* Advanced Params Section */}
        <div className="mb-6">
          <button className="flex items-center justify-between w-full text-left mb-4" style={{ color: 'var(--text-primary)' }}>
            <span>Advanced Params</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
            </svg>
          </button>
          
          {/* Parameter List */}
          <div className="space-y-3 text-sm">
            {[
              'Stream Chat Response',
              'Function Calling',
              'Seed',
              'Stop Sequence',
              'Temperature',
              'Reasoning Effort',
              'Logit Bias',
              'Mirostat',
              'Mirostat Eta',
              'Mirostat Tau',
              'Top K',
              'Top P',
              'Min P',
              'Frequency Penalty',
              'Presence Penalty',
              'Repeat Last N',
              'Tfs Z',
              'Tokens To Keep On Context Refresh',
              'Max Tokens (num_predict)',
              'Repeat Penalty (Ollama)',
              'Context Length (Ollama)',
              'Batch Size (num_batch)',
              'use_mmap (Ollama)',
              'use_mlock (Ollama)',
              'num_thread (Ollama)',
              'num_gpu (Ollama)'
            ].map((param, index) => (
              <div key={index} className="flex justify-between items-center">
                <span style={{ color: 'var(--text-secondary)' }}>{param}</span>
                <span style={{ color: 'var(--text-secondary)' }}>Default</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightSidebar;